var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.show ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "weight-submission-banner"
  }, [_c('div', {
    staticClass: "banner-content"
  }, [_c('div', {
    staticClass: "banner-text"
  }, [_c('span', {
    staticClass: "banner-title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('div', {
    staticClass: "countdown-inline"
  }, [_c('span', {
    staticClass: "countdown-label"
  }, [_vm._v("Time remaining:")]), _c('div', {
    staticClass: "countdown-badges"
  }, [_c('span', {
    staticClass: "countdown-badge days"
  }, [_vm._v(_vm._s(_vm.formattedTime.days) + "d")]), _c('span', {
    staticClass: "countdown-badge hours"
  }, [_vm._v(_vm._s(_vm.formattedTime.hours) + "h")]), _c('span', {
    staticClass: "countdown-badge minutes"
  }, [_vm._v(_vm._s(_vm.formattedTime.minutes) + "m")]), _c('span', {
    staticClass: "countdown-badge seconds"
  }, [_vm._v(_vm._s(_vm.formattedTime.seconds) + "s")])])])]), _c('div', {
    staticClass: "banner-actions"
  }, [_c('button', {
    staticClass: "submit-btn",
    attrs: {
      "disabled": _vm.isExpired || !_vm.hasStarted
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v(" " + _vm._s(_vm.buttonText) + " ")])])])])]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }